import { render, staticRenderFns } from "./SlidePage.vue?vue&type=template&id=40006150"
import script from "./SlidePage.vue?vue&type=script&lang=ts"
export * from "./SlidePage.vue?vue&type=script&lang=ts"
import style0 from "./SlidePage.vue?vue&type=style&index=0&id=40006150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports